import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAngi = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	"aria-label": "angi source icon",
	style: { color: "#E31837" },
	...props,
	children: /* @__PURE__ */ _jsx("text", {
		x: 32,
		y: 43,
		textAnchor: "middle",
		fontFamily: "Arial,Helvetica,sans-serif",
		fontSize: 31,
		fontWeight: 700,
		fill: "currentColor",
		children: "angi"
	})
});
export default SvgAngi;
